module.exports = __webpack_public_path__ + "img/flexible-character.d96d5760.svg";